/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2021-07-15 20:03:48
 * @LastEditors: guorui.teng 704386484@qq.com
 * @LastEditTime: 2023-04-07 16:06:15
 */
import React, {
  useState, useContext, useEffect, useRef,
} from 'react';
import propTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ikea from 'ikea-jssdk';
import { AidQuestionnaire } from '@aidesign/store';
import { AppContext } from '@/redux/store';
// import ArcButton from '@/components/arcButton';
import { goHome, jumpNewCSC } from '@/adaptPlatform/index';
import { PLATFORM, storeLeadsInfo } from '@/utils/util';
import { getPlatform } from '@/utils/rules/const';


import IconLogo from '@/assets/icon_ikeacn_logo.svg';
import IconGoOut from '@/assets/goOut.svg';
// import callEngine from '@/3DEngine/callEngine/index';
// import Loading from '@/components/Loading/loading';
import gioTrack, { getPageInfo } from '@/utils/track';
import { CSCText } from '@/utils/componentsUtils';
import ExitDesignDrawer from '@/components/exitDesign/exitDesignDrawer';
import useDetail from '@/pages/offer/useDetail';
import { GIO, getPageInfo as getPageInfoNew } from '@/utils/gio';
import arrow from '@/assets/arrow.svg';
import DesignerImage from '@/assets/modal_designer.png';
import navBarScss from './navBar.module.scss';
import BackImg from '../../assets/icon_back.png';
// import AppointImg from '../../assets/icon_appoint.png';
import close from '../../assets/icon_close_black.svg';

import AidBottomDialog from '../aidBottomDialog/AidBottomDialog';

const SurveyParamsConfig = {
  stepone: 'stepone',
  steptwo: 'steptwo',
  stepthree: 'stepthree',
  doorPlank: 'doorPlank',
  mesa: 'mesa',
  drawer: 'drawer',
  recommendStorage: 'drawer',
  offer: 'offer',
};

let prePathname = '';
function NavBar(props) {
  const { initState, dispatch } = useContext(AppContext);
  const { t } = useTranslation();
  const surveyRef = useRef(null);
  const { designCode } = initState;
  const { history } = props;
  const [visible, setVisible] = useState(false);
  const [drawVisible, setDrawVisible] = useState(false);
  const [title, setTitle] = useState('1/5尺寸选择');
  const [exitText, setExitText] = useState(t('navBar.directlyOut'));
  // const scrollDom = useRef();
  const { pathname } = history.location;
  const { addMyDesign } = useDetail();
  // const [isHarmony, setIsHarmony] = useState(false);

  function checkIsMainRouteChange(prePathname, pathName) {
    const getMainRouteName = (name = '') => {
      const reg = /\/home\/(?<main>\w+)(\/.+)?/;
      const result = name.match(reg);
      if (result) {
        return result.groups.main || '';
      }
      return '';
    };
    const preMainRoute = getMainRouteName(prePathname);
    const mainRoute = getMainRouteName(pathName);
    if (mainRoute === 'homepage') return true;
    return !(preMainRoute === mainRoute);
  }

  useEffect(() => {
    const url = window.location.href;
    const time = new Date().getTime();
    const isPathChange = checkIsMainRouteChange(prePathname, pathname);
    if (isPathChange) {
      GIO('pageView', {
        eventType_var: 'page_view',
      });
    }
    return () => {
      prePathname = pathname;
      const pageInfo = getPageInfoNew(pathname);
      const isPathChange = checkIsMainRouteChange(pathname, window.location.pathname);
      if (!isPathChange) return;
      GIO('pageView', {
        eventType_var: 'page_duration',
        period_var: ((new Date().getTime() - time) / 1000).toString(),
        pageId_var: url,
        pageType_var: pageInfo.pageType,
        pageName_var: pageInfo.pageName,
      });
    };
  }, [pathname]);

  const titleObj = {
    '/home/homepage/stepone': '1/5柜型尺寸选择',
    '/home/homepage/stepone/change': '1/5柜型尺寸选择',
    '/home/homepage/steptwo': '1/5柜型尺寸选择',
    '/home/homepage/steptwo/change': '1/5柜型尺寸选择',
    '/home/homepage/stepthree': '1/5柜型尺寸选择',
    '/home/homepage/stepthree/change': '1/5柜型尺寸选择',
    '/home/doorPlank': '2/5门板选择',
    '/home/doorPlank/change/type=1': '2/5门板选择',
    '/home/doorPlank/change/type=2': '2/5门板选择',
    '/home/mesa': '3/5台面选择',
    '/home/mesa/change/type=1': '3/5台面选择',
    '/home/mesa/change/type=2': '3/5台面选择',
    '/home/storage/drawer': '4/5内配储物',
    '/home/storage/drawer/change/link': '4/5内配储物',
    '/home/storage/basket': '4/5内配储物',
    '/home/storage/basket/change/link': '4/5内配储物',
    // 3105AB测试
    // A方案删除内容
    '/home/storage/recommendStorage': '4/5内配储物',
    '/home/storage/recommendStorage/change/link': '4/5内配储物',
    // A方案删除内容
    '/home/storage/sink': '4/5内配储物',
    '/home/storage/sink/change/link': '4/5内配储物',
    '/home/storage/sink/change/type=2': '4/5内配储物',
    '/home/storage/faucet': '4/5内配储物',
    '/home/storage/faucet/change/link': '4/5内配储物',
    '/home/storage/faucet/change/type=2': '4/5内配储物',
    '/home/storage/tallark': '4/5内配储物',
    '/home/storage/tallark/change/link': '4/5内配储物',
    '/home/storage/hand': '4/5内配储物',
    '/home/storage/hand/change/link': '4/5内配储物',
    '/home/storage/hand/change/type=2': '4/5内配储物',
    '/home/offer': '5/5厨房设计报价',
    '/home/doorPlank/change': '2/5门板选择',
    '/home/mesa/change': '3/5台面选择',
    '/home/storage/change': '4/5内配储物',
    '/case': '',
  };

  // useEffect(() => {
  //   ikea.currentPlatform().then((res) => {
  //     if (res.value?.platform.includes('Harmony')) {
  //       setIsHarmony(true);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const a = titleObj[pathname] ?? '厨房设计报价';
    setTitle(a);
  }, [pathname]);

  // 为元素添加事件监听
  const preventDefault = (flag) => {
    if (flag) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      document.querySelector('body').style.overflow = 'auto';
    }
  };

  // 点击退出设计
  const handleClickExitBtn = (e) => {
    setVisible(!visible);
    e.stopPropagation();
  };

  // 点击返回
  const clickBack = () => {
    GIO('clickData', {
      eventType_var: 'click',
      module_var: 'top_nav',
      objectName_var: '上一步',
    });
    if ((pathname.includes('stepone') && initState.arrowShow)
      || (pathname.includes('packOffer') && sessionStorage.getItem('typelink'))
    ) {
      sessionStorage.removeItem('typelink');
      goHome();
    } else {
      window.history.back();
      if (initState.currentTitle === '5/5厨房设计报价') {
        dispatch({ type: 'arrow-show', payload: true });
      }
    }

    // if (pathname.includes('/packOffer')) { // app厨房报价
    //   history.goBack();
    //   return;
    // }
    // // TODO
    // if (arrowShow) {
    //   Object.keys(titleList).forEach((key) => {
    //     if (titleList[key].title === currentTitle) {
    //       if (titleList[+key - 1]) {
    //         dispatch({ type: 'switch-nav', payload: titleList[+key - 1].title });
    //         dispatch({ type: 'switcharrow-show', payload: true });
    //         history.goBack();
    //         if (currentTitle === '5/5厨房设计报价') {
    //           dispatch({ type: 'storage-tab-nextTab', payload: true });
    //           Loading.show();
    //           callEngine(initState.engine3D, 'init', undefined, initState.jsonTemplate).then((reload) => {
    //             if (reload?.calloutLines) {
    //               dispatch({ type: 'calloutline', payload: reload.calloutLines });
    //             }
    //           }).finally(() => {
    //             Loading.hide();
    //           });
    //         }
    //         if (currentTitle === '4/5内配储物') {
    //           dispatch({ type: 'storage-tab-nextTab', payload: false });
    //         }
    //       } else if (pathname !== '/home/homepage/stepone') {
    //         history.goBack();
    //       } else {
    //         goHome();
    //         // props.history.goBack();
    //         // setVisible(!visible);
    //         // preventDefault(true);
    //       }
    //     }
    //   });
    // } else {
    //   history.goBack();
    //   dispatch({ type: 'arrow-show', payload: true });
    //   dispatch({ type: 'switch-nav', payload: '5/5厨房设计报价' });
    //   dispatch({ type: 'json-temporary', payload: {} }); // 清空暂存的TEMPLETE-JSON
    //   dispatch({ type: 'TemporaryDetail', payload: {} }); // 清空暂存的清单列表
    // }
  };

  const handleClickGoback = () => {
    clickBack();
  };
  const handleCancel = () => {
    setVisible(false);
    preventDefault(false);
  };
  const handleOk = () => {
    setVisible(false);
    preventDefault(false);
  };

  // ikeacn 点击LOGO返回首页    app直接退出返回首页   smp
  const handleClose = async (isSaveBtn = false) => {
    await surveyRef.current?.confirm(async (questionnaire, selected, remark) => {
      const { href } = window.location;
      const pageInfo = getPageInfo();
      const hasDesignCode = href.includes('offer');
      // const remarkStr = remark && `-${remark}`;
      const remarkStr = remark;
      gioTrack('clickData', {
        eventType_var: 'click',
        platform_var: getPlatform[localStorage.getItem('currentPlatform')],
        pageType_var: pageInfo.pageType,
        pageId_var: href,
        pageName_var: pageInfo.pageName,
        module_var: 'questionnaire_popup',
        modulePosition_var: '-',
        objectId_var: hasDesignCode ? window.sessionStorage.getItem('uniqueCode') || '-' : '-',
        objectType_var: 'exit',
        // eslint-disable-next-line no-nested-ternary
        objectName_var: isSaveBtn ? '退出并保存设计方案' : selected.length > 0 ? '提交并退出' : '直接退出',
        attributeName1_var: 'question_var',
        attributeValue1_var: questionnaire.join('-'),
        attributeName2_var: 'answer_var',
        attributeValue2_var: (selected.join('-') + remarkStr) || '-',
      });
    });
    handleCancel();
    // ikea.openH5('https://store-companion.ikea.cn/kitchen?channel=EC%20channel&cl_sr=KitchenTool_Back');
    goHome();
  };


  // 联系设计师-> 联系客服
  const contactDesigner = () => {
    handleCancel();
    let autoText = CSCText(pathname, '', initState.jsonTemplate, initState.getStepDetail.size);
    if (designCode && pathname.includes('/offer')) {
      autoText = `${t('navBar.kitchenPurchase')}`
        + `${t('navBar.combinationID', { num: designCode })}`
        + `${t('navBar.finishDesign',
          { designUrl: `https://kitchen.web.ikea.cn/kitchen-offline/quick/offer/${designCode}?type=link` })}`;
    }

    jumpNewCSC({ autoText });
    const {
      getStepDetail, houseState, serviceMark, capitalRetention, designCode: DesignCode,
    } = initState;
    const { size, totalCost } = getStepDetail;
    const { bottom, top } = size;
    gioTrack('submitAppointment', {
      page_var: window.location.href, // 页面URL
      pageSource_var: getPlatform[localStorage.getItem('currentPlatform')], // 页面来源
      designCode_var: DesignCode, // 设计代码
      size_var: bottom.len1 + bottom.len2 + bottom.len3 + top.len1 + top.len2, // 尺寸
      payAmount_var: totalCost,
      roomStatus_var: houseState, // 房屋状态
      reserveStoreID_var: serviceMark, // 用户预约的门店号
      ifSuccess_var: capitalRetention, // Y/N
    });
  };

  const setoutWebsite = () => {
    goHome();
  };

  const retainMask = () => {
    document.querySelector('body').style.overflow = 'hidden';
    // if (window.location.href.includes('offer') || window.location.href.includes('designList')) {
    setDrawVisible(true);
    // } else {
    //   setVisible(true);
    // }
  };

  // navbar退出按钮
  const outDesignBtn = () => (
    <div>
      <span
        className={navBarScss['smp-out-design']}
        role="none"
        onClick={handleClickExitBtn}
      >
        {t('exit_design')}

      </span>
    </div>
  );

  const outBackBtn = () => (
    <div
      className={navBarScss['app-back']}
      role="none"
      onClick={handleClickGoback}
    >
      <img className={navBarScss.backImg} src={IconGoOut} alt="" />
      <span className={navBarScss['app-out-design']}>
        {t('go_out')}
      </span>
    </div>
  );

  const getNavBar = () => {
    const titles = initState.titleList.filter((i) => pathname.includes(i.path));
    if (titles.length > 0) {
      return window.location.href.includes('id') && title?.split('/')[0] === '5' ? null
        : (
          <div className={navBarScss['smp-nav-content']}>
            <div>
              <span className={navBarScss['smp-title-first']}>{title?.split('/')[0]}</span>
              <span>{title?.substring(1, 3)}</span>
              <span>{title?.substring(3, title?.length)}</span>
            </div>
            {/* {outDesignBtn()} */}
          </div>
        );
    }
    return null;
  };

  const exitKt = () => {
    if (sessionStorage.getItem('isFromDesignList')) {
      ikea.navigateTo('ikea://design-project/my-planner-design');
    } else {
      goHome();
    }
  };

  const exitAndSaveDesign = async () => {
    await addMyDesign(true, {
      templateId: initState.jsonTemplate.mccId,
    });
    exitKt();
  };

  // console.log('tgr', isHarmony, PLATFORM() === 'smp' && !isHarmony);
  // 标题内容
  const TitleContent = () => {
    if (PLATFORM() === 'smp') {
      // 小程序标题
      return ((window.location.href.includes('id') && title?.split('/')[0] === '5') || pathname.includes('/packOffer')
        ? null : (
          <div className={navBarScss['smp-nav-content']}>
            <div>
              <span className={navBarScss['smp-title-first']}>{title?.split('/')[0]}</span>
              <span>{title?.substring(1, 3)}</span>
              <span>{title?.substring(3, title?.length)}</span>
            </div>
            {outDesignBtn()}
          </div>
        )
      );
    }
    if (PLATFORM() === 'app') {
      // app标题
      return (
        storeLeadsInfo()?.source === 'leads' ? (
          // 是leads进入显示左上角的标题，否则显示navbar
          (
            <div className={navBarScss['smp-nav-content']}>
              {pathname.includes('stepone') && initState.arrowShow ? null : outBackBtn()}
              <div className={navBarScss['smp-nav-span']}>
                <div className={navBarScss['smp-nav-div']}>
                  {
                    pathname.includes('/packOffer') ? (
                      <div className={navBarScss['smp-nav-div']}>
                        <span>{title?.split('/')[0]}</span>
                      </div>
                    ) : (
                      <div className={navBarScss['smp-nav-div']}>
                        <span className={navBarScss['smp-title-first']}>{title?.split('/')[0]}</span>
                        <span>{title?.substring(1, 3)}</span>
                        <span>{title?.substring(3, title?.length)}</span>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          )
        ) : (
          <div className={navBarScss['nav-content']}>
            {!window.location.href.includes('designList')
              && (
                <div className={navBarScss['nav-back']} role="none" onClick={() => clickBack()}>
                  <img src={BackImg} alt="" />
                </div>
              )}
            <div className={navBarScss['nav-title']}>
              {title}
            </div>
            {
              pathname.includes('/packOffer') ? null : (
                <div role="none" className={navBarScss['nav-title-close']} onClick={() => retainMask()}>
                  <img src={close} alt="" />
                </div>
              )
            }
          </div>
        )
      );
    }
    if (PLATFORM() === 'ikeacn' && pathname.includes('/packOffer')) {
      return null; // 官网并且是packOffer页面不显示navBar
    }
    if (sessionStorage.getItem('referrer') || storeLeadsInfo()?.source === 'leads') {
      return null;// 如果是leads过来的统一没有navbar
    }
    return (
      // 官网标题
      <>
        <div className={`${navBarScss['ikeacn-nav-content']} ${navBarScss['nav-content']} `}>
          <div
            className={navBarScss['nav-back']}
            role="none"
            onClick={() => setoutWebsite()}
          >
            <img
              src={IconLogo}
              alt=""
            />
          </div>
          <div className={navBarScss['nav-title']}>
            {t('navBar.kitchenQuotationTool')}
          </div>
          <div role="none" className={navBarScss['nav-title-close']} onClick={() => retainMask()}>
            <img src={close} alt="" />
          </div>
        </div>

        {getNavBar()}
      </>
    );
  };

  const getSurveyParams = () => {
    const currentKey = Object.keys(SurveyParamsConfig).find((item) => window.location.href.includes(item)) || 'index';
    return SurveyParamsConfig[currentKey];
  };

  return (
    <>
      <TitleContent />
      <div style={{
        visibility: drawVisible ? 'visible' : 'hidden',
      }}
      >
        <ExitDesignDrawer
          exit={() => {
            setDrawVisible(false);
            exitKt();
          }}
          isShowSaveBtn={window.location.href.includes('offer')}
          exitAndSaveDesign={() => {
            exitAndSaveDesign();
          }}
          goToCSC={contactDesigner}
          closeFn={(p) => { setDrawVisible(p); }}
        />
      </div>
      <AidBottomDialog
        visible={visible}
        onCancel={handleCancel}
        onOk={handleOk}
        height={null}
        ButtonCount={1}
        btnStyle={{
          okBtnName: '',
          cancelBtnName: '取消',
          btnWidth: 160,
          btnHeight: 52,
          centerWidth: '10px',
          backgroundColor: ['#0058b3'],
          BtnMarginBottom: '30px',
        }}
      >
        {/* <ArcButton
          position="absolute"
          top={-60}
          backgroundColor="rgb(255, 255, 255, 0.2)"
          width={9.875}
          height={2.5}
          margin="auto"
          text="点击暗区关闭海报"
          handleChecked={handleCancel}
        /> */}
        <div className={navBarScss['dialog-child']}>
          <div
            className={navBarScss['dialog-title']}
          // style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <h2>{t('navBar.noDesign')}</h2>
            <AidQuestionnaire
              onChange={(options, selected) => {
                if (selected.length) {
                  setExitText(t('saveAndExit'));
                } else {
                  setExitText(t('navBar.directlyOut'));
                }
              }}
              title="请告诉我们退出工具的原因（可多选）"
              pageName={getSurveyParams()}
              prdline="kitchen"
              ref={surveyRef}
              prefix={process.env.REACT_APP_BASE_URL}
            />
          </div>

          {/* <p className={navBarScss['title-text']}>{t('navBar.exclusiveService')}</p>
          <img className={navBarScss.groupImg} src={group} alt="" /> */}
          <div className={navBarScss.contactCsc}>
            <div className={navBarScss.cscLeft}>
              <div className={navBarScss.quitSubTitle}>
                设计中遇到困难或者想要咨询问题，我们有线上专业设计师免费为你服务。
              </div>
              <div
                role="none"
                className={navBarScss.quitConfirmBtn}
                onClick={contactDesigner}
              >
                联系线上设计师
                <img src={arrow} alt="" />
              </div>
            </div>
            <div className={navBarScss.cscRight}>
              <img className={navBarScss.quitDesigner} src={DesignerImage} alt="designer" />
            </div>
          </div>
          <div className={navBarScss['dialog-bottom']}>
            <p
              style={{ color: '#111', fontWeight: '700', fontSize: '0.75rem' }}
              className={navBarScss['dialog-btn']}
              role="presentation"
              onClick={() => handleClose()}
            >
              {/* {t('navBar.directlyOut')} */}
              {exitText}
            </p>
            {/* <ArcButton
              backgroundColor="#000"
              width={9.87}
              height={2.5}
              fontSize={0.75}
              text={t('navBar.designer')}
              handleChecked={contactDesigner}
            /> */}
          </div>
        </div>
      </AidBottomDialog>
    </>
  );
}

NavBar.propTypes = {
  // navId: propTypes.string,
  history: propTypes.shape({
    goBack: propTypes.func,
    push: propTypes.func,
    location: propTypes.shape({
      pathname: propTypes.string,
    }),
  }).isRequired,
};
NavBar.defaultProps = {
  // navId: '',
};

export default withRouter(NavBar);
